module.exports = __webpack_public_path__ + "b845b7eaea59bc0bac3dcbe4be96b746.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/rating.svg
// module id = 2653
// module chunks = 0